import { each } from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { getUnixTime } from "date-fns";

const dayInMilli = 86400000;

export const getInitialState = () => {
  return {
    key: getUnixTime(new Date()),
    selectedCarteira: undefined,
    selectedConvenio: undefined,
    selectedLoja: undefined,
    selectedProduto: undefined,
    selectedSituacoes: [
      { id: "02", descricao: "FILA ANÁLISE MANUAL" },
      { id: "04", descricao: "ANÁLISE MANUAL" },
      { id: "10", descricao: "PENDENTE" },
      { id: "11", descricao: "DESENQUADRADA" },
      { id: "27", descricao: "CADASTRO INCOMPLETO" },
    ],
    selectedStatus: undefined,
    selectedAnalista: undefined,
    dataInicio: getUnixTime(new Date(new Date() - 7 * dayInMilli)), //seven days ago
    dataFim: getUnixTime(new Date()), //today
    numeroCpf: "",
    numeroProposta: "",
    pedidoId: "",
    page: 0,
  };
};

const setState = (state, payload) => {
  each(payload, (value, name) => {
    state[name] = value;
  });
};

export const frontCreditoFilterSlice = createSlice({
  name: "front-credito-filters",
  initialState: getInitialState(),
  reducers: {
    setFilters: (state, { payload }) => {
      setState(state, payload);
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    clearFilters: (state) => {
      setState(state, getInitialState());
    },
  },
});

export const { setFilters, setPage, clearFilters } =
  frontCreditoFilterSlice.actions;

export default frontCreditoFilterSlice.reducer;
